import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { FormattedMessage } from "react-intl";
import ObjectUtils from "../../../../utils/ObjectUtils";
import { isColumnIncomplete } from "../../../../utils/QuestionUtils";

/**
 * Table question component (table head) for survey-view.
 */
const TableQuestionHead = ({ question, skipFirst, questionAnswer, rows }) => (
    <thead>
      <tr>
        {question.type === "dynamicTable" && <th className="bg-light shrink text-center">#</th>}
        {!skipFirst && <th />}
        {question.columns &&
          question.columns
            .filter((c) => c.visible !== false)
            .map((col, i) => (
              <OverlayTrigger
                key={i}
                placement="top"
                overlay={
                  <Tooltip id={`qTooltip${i}`}>
                    {col.infoText || col.text}
                    {col.required && " *"}
                  </Tooltip>
                }
              >
                <th
                  key={i}
                  className={`${ObjectUtils.toKebabCase(col.type)} text-truncate ${
                    isColumnIncomplete(col, questionAnswer, rows) ? "text-danger" : ""
                  }`}
                >
                  {col.required ? " * " : " "}
                  {col.text} {col.infoText && <FontAwesomeIcon icon={faInfoCircle} size="xs" />}
                </th>
              </OverlayTrigger>
            ))}
        {question.type === "dynamicTable" && (
          <th className="bg-light actions shrink">
            <FormattedMessage id="app.common.title.actions" />
          </th>
        )}
      </tr>
    </thead>
  );

TableQuestionHead.propTypes = {
  question: PropTypes.object.isRequired,
  skipFirst: PropTypes.bool,
  questionAnswer: PropTypes.object.isRequired,
  rows: PropTypes.array.isRequired
};

export default TableQuestionHead;
